import {
  asiakas_cacheName,
  cache_clear,
  cache_read,
  cache_write,
  sijainti_cacheName,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

async function clearCache() {
  cache_clear(sijainti_cacheName);
  cache_clear(asiakas_cacheName);
}

export function sijainti_calculateDistance(lattitude1, longittude1, lattitude2, longittude2) {
  const toRadian = (n) => (n * Math.PI) / 180;

  let lat2 = lattitude2;
  let lon2 = longittude2;
  let lat1 = lattitude1;
  let lon1 = longittude1;

  let R = 6371; // km
  let x1 = lat2 - lat1;
  let dLat = toRadian(x1);
  let x2 = lon2 - lon1;
  let dLon = toRadian(x2);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d;
}

// if sijaintiTypeId is null, then return all sijaintirows
export async function sijanti_getList(sijaintiTypeId, token, useCache = true) {
  const url1 = import.meta.env.VITE_SERVER_URL + "/api/geoCode/sijaintiList/" + sijaintiTypeId;
  if (useCache) {
    const c = cache_read(sijainti_cacheName, url1);
    if (c) return c;
  }
  const response = await fetch(url1, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "sijaintiClass:getSijaintiList");
  if (!cResponse.success) return [];
  const result = cResponse.data;
  cache_write(sijainti_cacheName, url1, result, 360);
  return result;
}

export async function sijainti_save_to_db(sijainti, token) {
  clearCache();
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(sijainti),
  };
  const url = import.meta.env.VITE_SERVER_URL + "/api/geocode/updateSijainti";
  const response = await fetch(url, requestOptions);
  return response.ok;
}

export async function sijainti_add_to_db(sijainti, token) {
  clearCache();
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(sijainti),
  };
  const url = import.meta.env.VITE_SERVER_URL + "/api/geocode/sijainti/add";
  const response = await fetch(url, requestOptions);
  return (await checkResponse(response, "sijaintiClass:addToDB")).data;
}

export async function sijanti_fetchList(asiakasId, token, useCache = true) {
  if (asiakasId == null || asiakasId == 0) return;
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/asiakas/sijainti/list/" + asiakasId;
  if (useCache) {
    const c = cache_read(sijainti_cacheName, fullUrl);
    if (c) return c;
  }
  try {
    const response = await fetch(fullUrl, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "asiakasClass.js:fetchAsiakasSijaintiList");
    if (!cResponse.success) return false;
    cache_write(sijainti_cacheName, fullUrl, cResponse.data, 360);
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function sijainti_delete_from_db(sijaintiId, token) {
  clearCache();

  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const url = import.meta.env.VITE_SERVER_URL + "/api/geocode/sijainti/delete/" + sijaintiId;
  const response = await fetch(url, requestOptions);
  const cResponse = await checkResponse(response, "sijaintiClass:deleteFromDB");
  return cResponse;
}

export async function sijainti_get(sijaintiId, token) {
  if (!sijaintiId) return { sijaintiId: 0, sijaintiNimi: "no sijaintiId" };
  if (sijaintiId == 0) return { sijaintiId: 0, sijaintiNimi: "notSelected" };
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/geoCode/sijainti/get/" + sijaintiId;
  const c = cache_read(sijainti_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "sijaintiClass:getSijainti");
  if (!cResponse.success) return false;
  cache_write(sijainti_cacheName, fullUrl, cResponse.data, 360);
  return cResponse.data;
}

export function sijanti_calculateDistance(lat1, lon1, lat2, lon2) {
  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
}

export async function sijainti_getClosestAsiakasSijaintiForTyomaa(
  tyomaaId,
  sijaintiId,
  sijaintiTypeId,
  asiakasId,
  token
) {
  if (!tyomaaId || !sijaintiId || !sijaintiTypeId) return false;
  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    "/api/geoCode/sijainti/getClosestAsiakasSijaintiForTyomaa/" +
    tyomaaId +
    "/" +
    sijaintiId +
    "/" +
    sijaintiTypeId +
    "/" +
    asiakasId;
  const c = cache_read(sijainti_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(
    response,
    "sijaintiClass:getClosestAsiakasSijaintiForTyomaa"
  );
  if (!cResponse.success) return false;
  cache_write(sijainti_cacheName, fullUrl, cResponse.data, 60);
  return cResponse.data;
}

export async function getLatLngFromAddress(osoite, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/geoCode/getLatLng/";
  const c = cache_read(sijainti_cacheName, fullUrl + osoite);
  if (c) return c;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ osoite: osoite }),
  };
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(response, "sijaintiClass:getLatLngFromAddress");
  if (!cResponse.success) return false;
  cache_write(sijainti_cacheName, fullUrl + osoite, cResponse.data, 1440);
  return cResponse.data;
}

export async function saveLatLng(sijaintiId, lat, lng, token) {
  cache_clear(sijainti_cacheName);
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/geoCode/updateLatLng/" + sijaintiId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ lat: lat, lng: lng }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}
